import { Skeleton, Box } from '@mui/material'
import React from 'react'

const CardTiles : React.FC<any> = ({
    label, value, currency, status, loading, count
}) => {
    return (
        <div className='tiles-paper'>
            { status ?
            <Box pl={2} pr={2}>
                <div><h4>{label}</h4></div>
                { loading ?
                <Skeleton height={60} width={30} /> :
                <div><h1>{value}</h1></div> }
            </Box>
            :
            <Box p={1} className="tiles-info">
                <div>
                    <h4>{label}</h4>
                    { loading ?
                        <Skeleton height={42} />
                    :
                    <div>
                    {!currency ? 
                        <h3>{value}</h3> :
                        <h3>Rp. {parseInt(value).toLocaleString()}</h3>
                    }
                    </div> }
                </div>
                <div>
                    <h1>{count}</h1>
                </div>
            </Box>
            }
        </div>
    )
}

export default CardTiles
